import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function parsedQueryString(search) {
  if (!search) {
    // react-router-dom places search string in the hash
    const hash = window.location.hash;
    search = hash.substring(hash.indexOf('?'));
  }
  if (!search || search.length <= 1) return {};
  const params = new URLSearchParams(search);
  const result = {};
  for (const [key, value] of params.entries()) {
    if (Object.prototype.hasOwnProperty.call(result, key)) {
      // keep first value to match qs parseArrays:false behaviour
      continue;
    }
    result[key] = value;
  }
  return result;
}

export default function useParsedQueryString() {
  const { search } = useLocation();
  return useMemo(() => parsedQueryString(search), [search]);
}
